import { render, staticRenderFns } from "./TabTripDocument.vue?vue&type=template&id=68f1e2d8&scoped=true"
import script from "./TabTripDocument.vue?vue&type=script&lang=js"
export * from "./TabTripDocument.vue?vue&type=script&lang=js"
import style0 from "./TabTripDocument.vue?vue&type=style&index=0&id=68f1e2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f1e2d8",
  null
  
)

export default component.exports